export const themes = {
  novated: {
    value: 'novated',
    logo: {
      white: 'logos/novated-white.svg',
      colour: 'logos/novated-logo-colour.svg',
      mobile: 'logos/novated_logo_mobile.svg'
    },
    support: {
      email: 'novated@fleetplus.com.au',
      phone: '1300 353 381'
    }
  },
  fleetPlus: {
    value: 'fleetPlus',
    logo: {
      white: 'logos/novated-fleet-plus-white.svg',
      colour: 'logos/novated-fleet-plus.svg',
      mobile: 'logos/novated_logo_mobile.svg'
    },
    support: {
      email: 'novated@fleetplus.com.au',
      phone: '1300 353 381'
    }
  },
  fleetPartners: {
    value: 'fleetPartners',
    logo: {
      white: 'logos/novated-fleet-partners-white.svg',
      colour: 'logos/novated-fleet-partners.svg',
      mobile: 'logos/novated_logo_mobile.svg'
    },
    support: {
      email: 'novated@fleetpartners.com.au',
      phone: '1300 666 001'
    }
  },
  fleetChoice: {
    value: 'fleetChoice',
    logo: {
      white: 'logos/novated-fleet-choice-white.svg',
      colour: 'logos/novated-fleet-choice.svg',
      mobile: 'logos/novated_logo_mobile.svg'
    },
    support: {
      email: 'novatedlease@fleetchoice.com.au',
      phone: '1300 34 33 88'
    }
  }
};

/**
 * Returns a theme for the given key defaulting to novated
 */
export default (theme) => {
  if (themes.hasOwnProperty(theme)) {
    return themes[theme];
  }
  return themes.novated;
};
